/**
 * 文章排序组件 xcc
 * */
import {DndProvider, DragSource, DropTarget} from "react-dnd";
import React, {Component} from "react";
// import {getWbnews, storySort} from "../actions";
import {Modal, Table, message, Select} from "antd";
import HTML5Backend from "react-dnd-html5-backend";
import Spin from "antd/es/spin";
import BaseComponent from "../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
import BaseTable from "../baseTable/BaseTable";
import moveIcon from './image/icon_5@2x.png'

const { Option } = Select;
let dragingIndex = -1;

class BodyRow extends React.Component {
    render() {
        const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
        const style = { ...restProps.style, cursor: 'move' };

        let { className } = restProps;
        if (isOver) {
            if (restProps.index > dragingIndex) {
                className += ' drop-over-downward';
            }
            if (restProps.index < dragingIndex) {
                className += ' drop-over-upward';
            }
        }

        return connectDragSource(
            connectDropTarget(<tr {...restProps} className={className} style={style} />),
        );
    }
}

const rowSource = {
    beginDrag(props) {
        dragingIndex = props.index;
        return {
            index: props.index,
        };
    },
};

const rowTarget = {
    drop(props, monitor) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Time to actually perform the action
        props.moveRow(dragIndex, hoverIndex);

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    },
};

const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}))(
    DragSource('row', rowSource, connect => ({
        connectDragSource: connect.dragSource(),
    }))(BodyRow),
);

const columns = [
        {
            title: '标题',
            dataIndex: 'title',
            key: 'title',
            width: "50%",
            ellipsis: true
        },
        {
            title: '置顶',
            dataIndex: 'wbtop',
            key: 'wbtop',
            render: function (text, record, index) {
                return text==="0" ? "否" : "是"
            }
        },
        {
            title: '发布时间',
            dataIndex: 'date',
            key: 'date'
        },
        {
            title:'操作',
            dataIndex:'operation',
            key:'operation',
            render:()=>{
                return(
                    <div>
                        <img src={moveIcon} style={{width: 20,marginTop: -2,marginRight: 5}}/>
                        <span style={{color:'#0050B3'}}>拖动排序</span>
                    </div>
                )
            }
        }
    ];

class DragSortingTable extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            visible : false,
            newsList : [],
            mediaCode : props.mediaCode,
            treeContentId : props.treeContentId
        };
    }

    componentDidMount() {
        this.loadTop10Wbnews();
    }

    components = {
        body: {
            row: DragableBodyRow,
        },
    };

    /**
     * 拖拽排序
     * @param dragIndex 拖拽行下标
     * @param hoverIndex 换到行的下标
     * dragIndex > hoverIndex 从下往上拖，反之从上往下拖
     * 从上往下拖 1，2，3
     *      1->2 2->3 3->1
     * 从下往上 1，2，3
     *      3->1 1->2 2->3
     */
    moveRow = (dragIndex, hoverIndex) => {
        const { newsList } = this.state;

        let dragRow = newsList[dragIndex];
        let hoverRow = newsList[hoverIndex];
        // if((dragRow.wbtop && !hoverRow.wbtop) || (!dragRow.wbtop && hoverRow.wbtop)){
        //     message.warn("置顶文章只能和置顶文章交换排序");
        //     return;
        // }
        if(dragRow.wbtop != hoverRow.wbtop){
            message.destroy();
            message.warn("置顶文章只能和置顶文章交换排序");
            return;
        }
        if(dragIndex < hoverIndex){
            for(let index = dragIndex; index < hoverIndex; index++){
                let indexRow = newsList[index];
                let indexRowOrder = indexRow.wborderfield;

                let nextIndex = index + 1;
                if(nextIndex > hoverIndex){
                    nextIndex = dragIndex;
                }
                let nextRow = newsList[nextIndex];
                let nextRowOrder = nextRow.wborderfield;
                // 交换排序字段
                indexRow.wborderfield = nextRowOrder;
                nextRow.wborderfield = indexRowOrder;

                // 交换下标
                newsList[index] = nextRow;
                newsList[nextIndex] = indexRow;
            }
        }else {
            for(let index = dragIndex; index > hoverIndex; index--){
                let indexRow = newsList[index];
                let indexRowOrder = indexRow.wborderfield;

                let prevIndex = index - 1;
                if(prevIndex < hoverIndex){
                    prevIndex = hoverIndex;
                }
                let preRow = newsList[prevIndex];
                let prevRowOrder = preRow.wborderfield;
                // 交换排序字段
                indexRow.wborderfield = prevRowOrder;
                preRow.wborderfield = indexRowOrder;

                // 交换下标
                newsList[index] = preRow;
                newsList[prevIndex] = indexRow;
            }
        }
        this.setState({newsList});
    };

    loadTop10Wbnews = (size) =>{
        let params = {
            mediaId : this.state.mediaCode,
            treeContentId : this.state.treeContentId,
            page: 1,
            size: size || 20,
        };
        this.request({
            url: "/cm-sites-pms/website/news/getNewsListByContentId",
            body: params,
            callBack: (res) => {
                let newsList = [];
                if(res){
                    newsList = res;
                }
                this.setState({newsList})
            }
        });
        // getWbnews(params, (data) =>{
        //     if(data.data){
        //         let newsList = JSON.parse(data.data);
        //         this.setState({newsList})
        //     }
        // })
    };

    render() {
        return (
            <DndProvider backend={HTML5Backend}>
                <Scrollbars autoHeight autoHide autoHeightMax={600}>
                    <Table
                        id={'storyTable'}
                        columns={columns}
                        dataSource={this.state.newsList}
                        components={this.components}
                        onRow={(record, index) => ({
                            index,
                            moveRow: this.moveRow,
                        })}
                        pagination={false}
                    >
                    </Table>
                </Scrollbars>
                <style>
                    {`#storyTable .ant-table-tbody .ant-table-row{border-bottom:1px solid #e8e8e8 } #storyTable .ant-table-content .ant-table-body table {border-collapse:collapse ! important}`}
                </style>
                {/*<div style={{*/}
                {/*    display: 'flex',*/}
                {/*    justifyContent: 'flex-end',*/}
                {/*    padding: '10px 10px 0 10px',*/}
                {/*}}>*/}
                {/*    <Select defaultValue="10" style={{width: 120}} onChange={(value) => {*/}
                {/*        this.loadTop10Wbnews(value * 1)*/}
                {/*    }}>*/}
                {/*        <Option key={1} value="10">每页10条</Option>*/}
                {/*        <Option key={2} value="20">每页20条</Option>*/}
                {/*    </Select>*/}
                {/*</div>*/}
            </DndProvider>
        );
    }
}

// ReactDOM.render(<DragSortingTable />, mountNode);
// #components-table-demo-drag-sorting tr.drop-over-downward td {
//     border-bottom: 2px dashed #1890ff;
// }
//
// #components-table-demo-drag-sorting tr.drop-over-upward td {
//     border-top: 2px dashed #1890ff;
// }

class StorySortModal extends BaseComponent {

    showModal = () => {
        this.setState({
            visible: true
        });
    };

    constructor(props) {
        super(props);
        this.state = {
            visible : false,
            spinning : false,
            newsList : [],
            mediaCode : props.mediaCode,
            treeContentId : props.treeContentId
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            mediaCode : nextProps.mediaCode,
            treeContentId : nextProps.treeContentId
        })
    }

    handleOk = () => {
        this.setState({
            spinning : true
        });
        var that = this;
        let wbnewsids = [];
        let wborderfields = [];
        let newsList = this.refs.dragSortingTable.state.newsList;
        newsList.forEach((item) =>{
            wbnewsids.push(item.id);
            wborderfields.push(item.wborderfield);
        });

        console.log("wbnewsids:" + wbnewsids.toString());
        console.log("wborderfields:" + wborderfields.toString());

        let params = {
            mediaId: this.state.mediaCode,
            newsIds : wbnewsids.toString(),
            orderfields : wborderfields.toString()
        };
        this.request({
            url: "/cm-sites-pms/website/news/storySort",
            body: params,
            method: "post",
            callBack: (res) => {
                // if (res) {
                    message.success("排序成功", 2, function () {
                        that.setState({
                            visible: false,
                            spinning: false
                        })
                    });
                // } else {
                //     message.error("排序失败", 2, function () {
                //         that.setState({
                //             spinning: false
                //         })
                //     });
                // }
            }
        });
        // storySort(params,function (data) {
        //     if(data.status === 200){
        //         message.info("排序成功", 2, function () {
        //             that.setState({
        //                 visible : false,
        //                 spinning : false
        //             })
        //         });
        //     }else {
        //         message.error("排序失败", 2,function () {
        //             that.setState({
        //                 spinning : false
        //             })
        //         });
        //     }
        //
        // });

    };

    handleCancel = () => {
        this.setState({
            visible : false
        });
    };

    render() {
        return (
            <Modal
                title="文章排序"
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                width={"65%"}
                destroyOnClose={true}
            ><Spin spinning={this.state.spinning}>
                <DragSortingTable mediaCode={this.state.mediaCode} treeContentId={this.state.treeContentId} ref={"dragSortingTable"}/>
            </Spin>
            </Modal>
        );
    }
}

export default StorySortModal;